import { IconButton } from 'copilot-design-system';
import {
  SendButtonProps,
  useMessageComposerHasSendableData,
} from 'stream-chat-react';

// created while referencing the default SendButton component
// https://github.com/GetStream/stream-chat-react/blob/master/src/components/MessageInput/SendButton.tsx
export const CustomSendButton = ({
  sendMessage,
  ...props
}: SendButtonProps) => {
  const hasSendableData = useMessageComposerHasSendableData();
  return (
    <IconButton
      className="p-[5px] rounded-md disabled:border-transparent"
      icon="SendFilled"
      aria-label="send"
      disabled={!hasSendableData}
      onClick={sendMessage}
      {...props}
    />
  );
};
